import { positiveOrNegative } from '../../utils/utils';

type Props = {
  balanceChange: any;
  totalBalance: any;
};

const Balance = ({ balanceChange, totalBalance }: Props) => {
  return (
    <div className="balance">
      <h2>Baccarat</h2>
      <div className="balance__text">
        <p>Balance:</p>
        <div className={`balance__value ${positiveOrNegative(balanceChange)}`}>
          <p>
            {balanceChange > 0 ? '+' : null}
            {balanceChange} BUSD
          </p>
          <p>{totalBalance} BUSD</p>
        </div>
      </div>
    </div>
  );
};

export default Balance;
